import React, { useState, useEffect } from "react";
import road from "../../asset/road.png";

const EndOfScrollComponent = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scaleFactor = Math.min(windowWidth / 378, 1.3);

  return (
    <div className="relative w-full min-h-[350px] sm:h-[30vh] overflow-hidden bg-black">
      <div className="absolute left-0 w-full px-6 sm:px-8 md:px-12">
        <div className="flex flex-col space-y-2">
          <h2
            style={{
              fontFamily: "'Guardian Sans XCond', sans-serif",
              fontWeight: 600,
              letterSpacing: "0.02em",
              wordSpacing: "0.1em",
              color: "#A7A7A7",
            }}
            className="text-4xl mt-6 sm:text-6xl md:text-7xl lg:text-8xl tracking-wider text-left"
          >
            End of scroll.
          </h2>

          <div className="flex flex-col space-y-2">
            <h2
              style={{
                fontFamily: "'Guardian Sans XCond', sans-serif",
                fontWeight: 600,
                letterSpacing: "0.02em",
                wordSpacing: "0.1em",
                color: "#EDEDED",
              }}
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-wider text-left"
            >
              Beginning of an
            </h2>
            <h2
              style={{
                fontFamily: "'Guardian Sans XCond', sans-serif",
                fontWeight: 600,
                letterSpacing: "0.02em",
                wordSpacing: "0.1em",
                color: "#EDEDED",
              }}
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-wider text-left"
            >
              adventure.
            </h2>
          </div>
        </div>
      </div>

      <img
        src={road}
        alt="Road"
        className="absolute bottom-0 w-full object-cover"
        style={{
          maxHeight: "45%",
        }}
      />
    </div>
  );
};

export default EndOfScrollComponent;
